import { UnorderedList, ListItem, Text } from '@chakra-ui/react';
import { RequirementsSummary } from 'shared-components';

interface IProps {
  uploadComplete: boolean;
  highlightedSections: string[];
}

export default function Requirements(props: IProps) {
  const allSections = [
    '1.1',
    '1.2',
    '1.3',
    '1.4',
    '2.1',
    '2.2',
    '3.1',
    '3.2',
    '3.3',
    '3.4',
    '4.1',
    '4.2',
    '4.3',
    '4.4',
    '5.1',
    '5.2',
    '5.3'
  ];
  const sectionsToShow =
    props.highlightedSections && props.highlightedSections.length ? props.highlightedSections : allSections;

  return (
    <>
      {sectionsToShow.join('').indexOf('1.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'1. We have to be sure your statement is authentic'}
        >
          {sectionsToShow.includes('1.1') || sectionsToShow.includes('1.2') ? (
            <UnorderedList>
              {sectionsToShow.includes('1.1') ? (
                <ListItem>All statements must display the logo and name of the bank</ListItem>
              ) : null}
              {sectionsToShow.includes('1.2') ? (
                <ListItem>It must have a date at the top of the document</ListItem>
              ) : null}
            </UnorderedList>
          ) : null}

          {sectionsToShow.includes('1.3') ? (
            <>
              <Text mt={4} mb={2}>
                For paper statements:
              </Text>

              <UnorderedList>
                <ListItem>It should be stamped and signed by the bank (optional)</ListItem>
              </UnorderedList>
            </>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('2.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'2. We must be able to see your connection to the account'}
        >
          <UnorderedList>
            {sectionsToShow.includes('2.1') ? (
              <ListItem>The statement must show your parent/guardian's name and the account number</ListItem>
            ) : null}
            {sectionsToShow.includes('2.2') ? (
              <ListItem>The name must match your birth certificate or proof of guardianship</ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('3.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'3. Statement must be in English or have an English translation'}
        >
          {sectionsToShow.includes('3.1') ? (
            <>
              <Text mt={4} mb={2}>
                For statements in English:
              </Text>

              <UnorderedList>
                <ListItem>Nothing further required</ListItem>
              </UnorderedList>
            </>
          ) : null}
          {sectionsToShow.includes('3.2') || sectionsToShow.includes('3.3') || sectionsToShow.includes('3.4') ? (
            <>
              <Text mt={4} mb={2}>
                For statements not in English:
              </Text>

              <UnorderedList>
                {sectionsToShow.includes('3.2') ? (
                  <ListItem>A translation must be included with the statement</ListItem>
                ) : null}
                {sectionsToShow.includes('3.3') ? (
                  <ListItem>The translation must be signed and dated by a qualified translator</ListItem>
                ) : null}
                {sectionsToShow.includes('3.4') ? (
                  <ListItem>Contact details and credentials for the translator must be included</ListItem>
                ) : null}
              </UnorderedList>
            </>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('4.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'4. We must be able to see details for all transactions on the statement '}
        >
          {sectionsToShow.includes('4.1') || sectionsToShow.includes('4.2') ? (
            <UnorderedList>
              {sectionsToShow.includes('4.1') ? (
                <ListItem>
                  The statements normally should have a running total next to every transaction made during the
                  statement period
                </ListItem>
              ) : null}
              {sectionsToShow.includes('4.2') ? (
                <ListItem>
                  There must be a closing balance at the end of the statement with a date alongside it (within 31 days)
                </ListItem>
              ) : null}
            </UnorderedList>
          ) : null}
          {sectionsToShow.includes('4.3') ? (
            <>
              <Text mt={4} mb={2}>
                For statements in British pounds:
              </Text>

              <UnorderedList>
                <ListItem>Nothing further required</ListItem>
              </UnorderedList>
            </>
          ) : null}
          {sectionsToShow.includes('4.4') ? (
            <>
              <Text mt={4} mb={2}>
                For statements in another currency:
              </Text>

              <UnorderedList>
                <ListItem>The currency must be shown on the statement</ListItem>
              </UnorderedList>
            </>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('5.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'5. Your funds must have been in the account for at least 28 consecutive days'}
        >
          <UnorderedList>
            {sectionsToShow.includes('5.1') ? (
              <ListItem>The full amount must be visible in the account</ListItem>
            ) : null}
            {sectionsToShow.includes('5.2') ? (
              <ListItem>
                The statement must show that the account did not fall below the required amount in the 28 days prior to
                the closing balance date
              </ListItem>
            ) : null}
            {sectionsToShow.includes('5.3') ? (
              <ListItem>
                Ensure the closing balance date gives us a long enough timespan to verify the full period
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}
    </>
  );
}
